module.exports = __webpack_public_path__ + "static/img/GRAB.cc35825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/GRAB.png
// module id = uFku
// module chunks = 0